import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quag501: IProductData = {
  id: "quag-501-plus",
  name: "Quagliardi 501+",
  description: "500 series preamp with color options.",
  images: ["/img/quag_501_front.png", "/img/quag_501_right.png"],
  details: [{
    label: "Description",
    markdown: `
This powerful 500 series module delivers a clear and transparent response at low and medium gains while adding a distinctive and colorful character when pushed into saturation. 
Equipped with a permalloy transformer and the legendary 2520 operational amplifier. 
Additionally, it features a combo connector on the front panel, allowing you to connect an alternate low-impedance XLR or a high-impedance instrument in DI mode.
`
  }, {
    label: "Specifications",
    markdown: `
- Connections
- Front Panel: Inputs on combo connector (XLR balanced + Hi-Z 1/4" unbalanced). Output on rear connector, MIC Input on rear connector.
- Gain Range
- Mic: 38dB - 78dB (18dB - 58dB with pad), Hi-Z: 17dB - 57dB
- Max Input Level
- Mic: -11.8dBu (8.5dBu with pad), Hi-Z input: +9.7 dBu
- Input Impedance
- Mic: 450 Ω / 750 Ω (with pad) @150 Ω mic, Hi-Z input: 1 MΩ
- Output Impedance
- Less than 10 Ω (variable output attenuator)
- Max Output Level
- +30 dBu
- Freq. Response
- +0.45dB@20Hz / -1.3dB@20kHz, +0.6dB@20Hz / -0.3dB@20kHz (with XREL)
- Equivalent Input Noise
- -130 dB
- Power Consumption
- +/-16 Volts DC @ 60 mA
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/500-series-modules/" target="_blank">https://quagliardiaudio.com/500-series-modules/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.SINGLE_SLOT, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.API_500],
    manufacturer: BRAND.QUAGLIARDI,
  }
}